import React, { useMemo } from 'react';
import './StarsBackground.css';

const StarsBackground: React.FC = () => {
  const stars = useMemo(() => {
    // We use 50 stars to cover the whole screen.
    return Array.from({ length: 50 }).map((_, i) => ({
      id: i,
      left: `${Math.random() * 100}%`,
      top: `${Math.random() * 100}%`,
      animationDelay: `${Math.random() * 4.5}s`,
      animationDuration: `${3.5 + Math.random() * 3}s`,
    }));
  }, []);

  return (
    <div className="stars-container" aria-hidden="true">
      {stars.map((star) => (
        <span
          key={star.id}
          className="star"
          style={{
            left: star.left,
            top: star.top,
            animationDelay: star.animationDelay,
            animationDuration: star.animationDuration,
          }}
        />
      ))}
    </div>
  );
};

export default StarsBackground;
